export { default } from './NFTManagerContainer';
